import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'

import routes, { fallbacks } from './routes'
import { routeFallback } from '../utils/routeFallback'
import { check } from '../utils/roles'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(async (to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!localStorage.getItem('token')) {
      next('/login')
      return
    }
    if (from.path === '/') {
      await store.dispatch('User/login')
    }
    if (to.matched.some(record => record.meta.restricted)) {
      const policies = store.getters['User/policies']
      for (const route of to.matched) {
        if (route.meta?.restricted) {
          if (!check(policies, route.meta.restricted)) {
            next(routeFallback(routes[0].children, fallbacks, policies))
            return
          }
        }
      }
    }
  }
  next()
  return
})

export default router
